export default "__VITE_ASSET__C9HlvChf__"